import { ILoading } from "../models";
import {
    GET_FUNDS_START,
    GET_FUNDS_END,
	GET_FUND_START,
	GET_FUND_END,
	TOGGLE_LOADING,
	Actions,
	GET_SHARE_CLASSES_START,
	GET_SHARE_CLASSES_END
} from "../actions";
import { appendToLoading, removeFromLoading } from "../utils";

export function loadingReducer(state: ILoading = { isLoading: false }, action:Actions) {
	let current;
	switch (action.type) {
		case GET_FUNDS_START:
			current = Object.assign({}, state, { errorMessage: null, testing:'1' });
			appendToLoading(current, 'funds');
			return current;
		case GET_FUNDS_END:
			current = Object.assign({}, state, { errorMessage: action["error"] ? "There was a problem with loading the shares." : null });
			removeFromLoading(current, 'funds');
			return current;
		case GET_FUND_START:
			current = Object.assign({}, state, { errorMessage: null, testing:'1' });
			appendToLoading(current, 'fund');
			return current;
		case GET_FUND_END:
			current = Object.assign({}, state, { errorMessage: action["error"] ? "There was a problem with loading the shares." : null });
			removeFromLoading(current, 'fund');
			return current;
		case GET_SHARE_CLASSES_START:
			current = Object.assign({}, state, { errorMessage: null, testing:'1' });
			appendToLoading(current, 'shareClass');
			return current;
		case GET_SHARE_CLASSES_END:
			current = Object.assign({}, state, { errorMessage: action["error"] ? "There was a problem with loading the shares." : null });
			removeFromLoading(current, 'shareClass');
			return current
		case TOGGLE_LOADING:
			return Object.assign({}, state, { isLoading: !state.isLoading, errorMessage: null, testing:'1' });
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/client/reducers/loading.ts